import {
  getStatisticalData, getCrmAndTodoDate, importCustomsData,
  queryCustomsData, importSmartPushData, getSmartPushData, importCustomData,
  importApprovePlantData, importExportToChinaData, importCountrySlaughterData,
  importPlantSlaughterData, importGreyChannelData, getCustomData,
  getApprovePlantData, getExportToChinaData, getCountrySlaughterData,
  getPlantSlaughterData, getGreyChannelData, importPorkData, getPorkData,
  importPorkCustomsData, getPorkCustomsData, importPorkEstData, getPorkEstData,
  updateApprovePlantState, getPlantCategoryCount, getPlantConditionCount,
  uploadAdvertisement2688, uploadAdvertisement2208, getPlantUpdateState, addPlantUpdateState, importBtcPriceData,
  importLiveCattle, updatePorkDataEst, updatePorkEstDataState, importPorkAppData, getPorkNewData, getPorkNewCustomsData
} from '@/api/data'

const bdnote = {
  state: {
    total: 0,
    rows: [],
    row: {}
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    }
  },
  actions: {
    // 查询统计数据
    GetStatisticalData({ commit }) {
      return new Promise((resolve, reject) => {
        getStatisticalData().then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取CRM和待办日期
    GetCrmAndTodoDate({ commit }, userid) {
      return new Promise((resolve, reject) => {
        getCrmAndTodoDate(userid).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入海关数据（旧）
    ImportCustomsData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importCustomsData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据（旧）
    QueryCustomsData({ commit }, params) {
      return new Promise((resolve, reject) => {
        queryCustomsData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入智推数据
    ImportSmartPushData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importSmartPushData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询智推数据
    GetSmartPushData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSmartPushData(params).then(response => {
          commit('SET_ROWS', response.Data.Res)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // ---------------------------- 必孚数据相关接口---------------------

    // 导入海关数据
    ImportCustomData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importCustomData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入准入工厂数据
    ImportApprovePlantData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importApprovePlantData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入输华离港数据
    ImportExportToChinaData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importExportToChinaData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入国家屠宰数据
    ImportCountrySlaughterData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importCountrySlaughterData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入工厂屠宰数据
    ImportPlantSlaughterData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importPlantSlaughterData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入印越港数据
    ImportGreyChannelData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importGreyChannelData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询海关数据
    GetCustomData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCustomData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询准入工厂数据
    GetApprovePlantData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getApprovePlantData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改准入工厂状态
    UpdateApprovePlantState({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateApprovePlantState(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询输华离港数据
    GetExportToChinaData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getExportToChinaData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询国家屠宰数据
    GetCountrySlaughterData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCountrySlaughterData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询工厂屠宰数据
    GetPlantSlaughterData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPlantSlaughterData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询印越港数据
    GetGreyChannelData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getGreyChannelData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入破壳数据
    ImportPorkData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importPorkData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询破壳数据
    GetPorkData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPorkData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入破壳海关数据
    ImportPorkCustomsData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importPorkCustomsData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询破壳海关数据
    GetPorkCustomsData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPorkCustomsData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入破壳工厂数据
    ImportPorkEstData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importPorkEstData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询破壳工厂数据
    GetPorkEstData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPorkEstData(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询必孚工厂搜索类别点击次数
    GetPlantCategoryCount({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPlantCategoryCount(params).then(response => {
          commit('SET_ROWS', response.Data.Row.data)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询必孚工厂搜索条件点击次数
    GetPlantConditionCount({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPlantConditionCount(params).then(response => {
          commit('SET_ROWS', response.Data.Row.data)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 上传App广告
    UploadAdvertisement2688({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadAdvertisement2688(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UploadAdvertisement2208({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadAdvertisement2208(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPlantUpdateState({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPlantUpdateState(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddPlantUpdateState({ commit }, params) {
      return new Promise((resolve, reject) => {
        addPlantUpdateState(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入行情数据
    ImportBtcPriceData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importBtcPriceData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入活牛数据
    ImportLiveCattle({ commit }, params) {
      return new Promise((resolve, reject) => {
        importLiveCattle(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改准入工厂厂号数据
    UpdatePorkDataEst({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePorkDataEst(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改准入工厂状态
    UpdatePorkEstDataState({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePorkEstDataState(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入App破壳数据
    ImportPorkAppData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importPorkAppData(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询App破壳数据
    GetPorkNewData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPorkNewData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询App破壳海关数据
    GetPorkNewCustomsData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPorkNewCustomsData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default bdnote



// WEBPACK FOOTER //
// ./src/store/modules/data.js